import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerloopChatComponent } from './verloop-chat.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    VerloopChatComponent
  ],
  exports: [
    VerloopChatComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class VerloopChatModule { }
